import React from 'react';
import _ from 'lodash';

export default function Hit(data) {
  const { hit, additionalData, results } = data;
  const {
    id,
    title,
    uri,
    galleryTagline,
    locations,
    participations,
  } = hit;
  const activeLocations = results.getRefinements()
    .filter((item) => item.attributeName === 'location')
    .map((item) => item.name);

  const {
    exhibitors,
    fair,
  } = additionalData;

  let activeFair = fair ?? null;
  if (!activeFair) {
    const fairs = results.getRefinements()
      .filter((item) => item.attributeName === 'fair')
      .map((item) => item.name);
    activeFair = fairs.length > 0 ? fairs[0] : null;
  }

  let locationIndex = 0;
  if (activeLocations && locations) {
    Object.keys(locations).forEach((key) => {
      if (activeLocations.includes(locations[key].country)) {
        locationIndex = key;
      }
    });
  }
  const image = _.get(
    hit,
    `locations[${locationIndex}].image.transforms.catalog.url`,
    _.get(
      hit,
      `locations[${locationIndex}].image.url`,
      '/dist/images/exhibitor-fallback-image.jpg',
    ),
  );
  const imageWidth = _.get(
    hit,
    `locations[${locationIndex}].image.transforms.catalog.width`,
  );
  const imageHeight = _.get(
    hit,
    `locations[${locationIndex}].image.transforms.catalog.height`,
  );
  const city = _.get(hit, `locations[${locationIndex}].city`, null);

  let standNumber = null;
  if (activeFair) {
    const participation = (participations || [])
      .find((p) => p.fair?.title === activeFair);
    if (participation) {
      standNumber = participation.standNumber || null;
    }
  }

  return (
    <div className="col-md-6 col-xl-4" key={id}>
      <a
        href={window.Craft.getSiteUrl(uri, '')}
        className={`item${standNumber ? ' item-stand-number' : ''}`}
      >
        {image && (
          <picture>
            <img
              src={image}
              alt={city || ''}
              width={imageWidth}
              height={imageHeight}
            />
          </picture>
        )}
        <div className="item-inner item-inner-secondary">
          <h3 className="mb-0 h2">{title}</h3>
          <div className="hover-info">
            <hr className="my-4" />
            <div className="d-flex justify-content-between">
              <span className="me-4">{galleryTagline}</span>
              <button type="button" className="btn btn-sm btn-outline-light flex-shrink-0 h-100">
                {window.Craft.t(exhibitors, 'More Info', {})}
              </button>
            </div>
          </div>
        </div>
        {(standNumber) && (
          <div className="item-inner item-inner-secondary stand-number fw-medium">
            {window.Craft.t(exhibitors, 'Stand {standNumber}', { standNumber })}
          </div>
        )}
      </a>
    </div>
  );
}
